export default "__VITE_ASSET__BrOgPYPy__"